import React from "react";
import { connect } from "react-redux";
import { Switch, withRouter } from 'react-router-dom';
import { compose } from 'redux';
// import PushPropertiesDialog, { usePushPropertiesDialog } from "components/explore/pushPropertiesDialog";
import Gmap from "components/explore/gmap";
import ExploreResults from "components/explore/ExploreResults";
import PropertyDetailsPage from "components/explore/propertyDetailsPage";
import { ExploreImport } from 'components/explore/import';
import { ProspectorRoutes } from 'components/explore/prospector';
import LoadingSnackbar from "components/explore/common/LoadingSnackbar";
import { SnackbarProvider } from 'notistack';
import { SimpleDialogProvider } from 'components/explore/prospector/Dialog';
import { ViewsPanel } from 'components/explore/views';
import { makeStyles } from "@material-ui/styles";
import { Constants } from 'utilities/constants';
import AuthorizedRoute from 'routes/AuthorizedRoute';
import { userRoleSourcingUserSelector, userRoleExploreSelector } from 'store/selectors';
import { Paper, IconButton, Tooltip } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import { setIsSideBarOpen } from 'store/actions';

const useStyles = makeStyles(theme => ({
  container: {
    width: '100%',
    display: 'flex',
    position: 'relative'
  },
  stack: {
    height: '100%',
    width: '100%',
    display: 'flex',
    overflow: 'hidden',
    flexFlow: 'column wrap',
  }
}));

export const MapRefContext = React.createContext(null);

function Explore({ isMobile, isSideBarOpen }) {
  const classes = useStyles();
  const mapRef = React.useRef(null);

  const onSideBarToggleClick = () => {
      setIsSideBarOpen(!isSideBarOpen)
  }

  return (
    <>
      <MapRefContext.Provider value={mapRef}>
        <div className={classes.container}>
            <ViewsPanel />
              <Tooltip title={`Map Options`} placement="bottom">
              <Paper style={{ position: 'absolute', top: 0, margin: 10 }}>    
                  <IconButton                 
                      onClick={onSideBarToggleClick}
                      >
                      <MenuIcon />
                  </IconButton>                        
                </Paper>  
              </Tooltip>    
          <div className={classes.stack}>
            <Gmap mapRef={mapRef} isMobile={isMobile} />
            <ExploreResults isMobile={isMobile}
            // openPushPropertiesModal={openPushPropertiesModal}
            />
          </div>
        </div>
      </MapRefContext.Provider>
      {/* <PushPropertiesDialog open={pushPropertiesModalOpen} onClose={closePushPropertiesModal} /> */}
      <LoadingSnackbar />
    </>
  )
}

function ExploreRoutes({ setProspectorModalOpen, prospectorModalOpen,
  history, userHasSourcingUserRole, refreshProspectsGrid, setRefreshProspectsGrid, userHasExploreRole, isMobile, isSideBarOpen }) {
  return (
    <SnackbarProvider maxSnack={3}>
      <SimpleDialogProvider>
        <Switch>
          <AuthorizedRoute exact path={Constants.Routes.EXPLORE} title={Constants.RouteTitles.EXPLORE} isAuthorized={userHasExploreRole} render={(props) => (
            <Explore isMobile={isMobile} isSideBarOpen={isSideBarOpen} />
          )} />
          <AuthorizedRoute path={Constants.Routes.EXPLORE_IMPORT} title={Constants.RouteTitles.EXPLORE_IMPORT }isAuthorized={userHasSourcingUserRole} render={(props) => (
            <ExploreImport />
          )} />
          <AuthorizedRoute path={Constants.Routes.EXPLORE_PROSPECTOR} isAuthorized={userHasSourcingUserRole} render={(props) => (
            <ProspectorRoutes {...props} history={history} setProspectorModalOpen={setProspectorModalOpen} prospectorModalOpen={prospectorModalOpen} refreshProspectsGrid={refreshProspectsGrid} setRefreshProspectsGrid={setRefreshProspectsGrid} />
          )} />
        </Switch>
      </SimpleDialogProvider>
    </SnackbarProvider>
  )
}

const mapState = (state) => {
  return {
    userHasSourcingUserRole: userRoleSourcingUserSelector(state),
    userHasExploreRole: userRoleExploreSelector(state),
    isMobile: state.appState.isMobile,
    isSideBarOpen: state.exploreViews.isSideBarOpen
  };
}

export default compose(
  connect(mapState),
  withRouter,
)(ExploreRoutes);